import React, { Component } from "react";
import ArticleGalleryImage from './ArticleGalleryImage';
import WithConsumer from '../context/WithConsumer';


export default class ArticleGallery extends Component {
    render () {
	    let post = this.props.post;
		if (post.gallery) {
		    let thumbs = post.gallery.map((image,i) =>
		    	<ArticleGalleryImage key={i} image={image}></ArticleGalleryImage>
		    );
		    return (
			    <div>
			        {post.gallery &&
		    			<div className="c-article__images">
		    				<h3 className="c-article__images__heading">Gallery</h3>
		    				<div className="c-article__images__list">
		    					{thumbs}
		    				</div>
		    			</div>
					}
				</div>
			)
		} else {
			return null;
		}
	};

};
